import $ from 'jquery'
export default {
  mounted () {
    this.$emit('cerrar-modal')
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  },
  methods: {

  },
  detroyed () {
    $('body').removeClass('miclase')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/UserLogged.js